import TaskVisualIcon from "@/components/training/TaskVisualIcon";
import { visualKindForDetailedCategory } from "@/training/taskVisuals";

/**
 * Canonical detailed driving criteria — shared by Detailed Assessment and Mock / Readiness.
 */
export default function DetailedCriteriaPanel({
  categories,
  selectedSkills,
  onToggleSkill,
  onSetSkillScore,
  openDetailed,
  onToggleCategory,
  testIdPrefix = "det",
  disabled = false,
}) {
  return (
    <div className="space-y-3" data-testid={`${testIdPrefix}-criteria-panel`}>
      <p className="text-sm text-muted-foreground">
        Canonical detailed driving criteria (educational only). Same skill set for progress reviews and mock/readiness
        sessions.
      </p>
      {(categories || []).map((cat) => (
        <details
          key={cat.category_id}
          className="border rounded p-3"
          open={!!openDetailed?.[cat.category_id]}
          onToggle={(e) => onToggleCategory?.(cat.category_id, e.target.open)}
          data-testid={`${testIdPrefix}-cat-${cat.category_id}`}
        >
          <summary className="font-semibold cursor-pointer min-h-11 py-2 flex items-center gap-2 list-none">
            <span className="inline-flex w-8 h-8 items-center justify-center shrink-0" aria-hidden="true">
              <TaskVisualIcon kind={visualKindForDetailedCategory(cat.category_id)} />
            </span>
            <span>{cat.name}</span>
          </summary>
          <ul className="mt-2 space-y-2">
            {(cat.sub_skills || []).map((s) => (
              <li key={s.skill_id} className="flex flex-wrap items-center gap-2">
                <button
                  type="button"
                  className={`min-h-11 px-3 py-2 rounded border text-sm ${
                    s.skill_id in selectedSkills ? "bg-primary text-primary-foreground" : ""
                  }`}
                  onClick={() => onToggleSkill(s.skill_id)}
                  disabled={disabled}
                  data-testid={`${testIdPrefix}-skill-${s.skill_id}`}
                >
                  {s.label}
                </button>
                {s.skill_id in selectedSkills && (
                  <select
                    className="border rounded px-2 py-2 min-h-11"
                    value={selectedSkills[s.skill_id]}
                    onChange={(e) => onSetSkillScore(s.skill_id, e.target.value)}
                    data-testid={`${testIdPrefix}-score-${s.skill_id}`}
                    aria-label={`Score for ${s.label}`}
                    disabled={disabled}
                  >
                    <option value="">Unscored</option>
                    {[1, 2, 3, 4, 5].map((n) => (
                      <option key={n} value={n}>
                        {n}
                      </option>
                    ))}
                  </select>
                )}
              </li>
            ))}
          </ul>
        </details>
      ))}
    </div>
  );
}
